interface PersonInsideMessageBubbleAndHandSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PersonInsideMessageBubbleAndHandSVG = ({
  color,
  style,
}: PersonInsideMessageBubbleAndHandSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="69"
    height="50"
    viewBox="0 0 69 50"
    fill="none"
  >
    <g clipPath="url(#clip0_3349_71030)">
      <path
        d="M23.8203 22.1621C23.8203 22.1621 28.4919 24.704 30.3194 26.1605C30.759 26.504 31.1163 26.9299 31.4186 27.3971C31.9682 28.2764 32.2155 29.2932 32.2155 30.3374V34.8442"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M32.2023 34.8442H6V30.3374C6 29.3069 6.26106 28.2764 6.79692 27.3971C7.08546 26.9299 7.45644 26.504 7.89613 26.1605C9.70981 24.704 14.3952 22.1621 14.3952 22.1621"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M25.7022 16.4195C25.7022 20.94 22.748 24.6086 19.1069 24.6086C15.4658 24.6086 12.5117 20.94 12.5117 16.4195C12.5117 11.8991 15.4658 8.23047 19.1069 8.23047C22.748 8.23047 25.7022 11.8991 25.7022 16.4195Z"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M48.4688 6.41669C48.4688 3.2977 50.9969 0.769531 54.1159 0.769531C57.2349 0.769531 59.7631 3.2977 59.7631 6.41669"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M67.8744 24.9248C67.8744 24.9248 67.7919 28.14 66.3355 30.7781C64.3981 34.323 62.4883 36.9886 62.4883 41.4266"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M60.2311 19.7867C60.3822 15.1563 60.6296 13.9609 59.654 13.2876C58.5411 12.5319 57.4281 13.4663 56.5625 14.3181"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M64.0514 22.0132C64.2025 17.3828 64.4499 16.1875 63.4743 15.5142C62.3614 14.7585 61.2484 15.6928 60.3828 16.5447"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M67.8717 24.9263C68.0229 20.2959 68.2702 19.1005 67.2946 18.4273C66.1817 17.6716 65.0687 18.6059 64.2031 19.4578"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M46.625 49.2312V42.8146C46.625 42.0451 47.257 41.4131 48.0265 41.4131H63.6077C64.3771 41.4131 65.0092 42.0451 65.0092 42.8146V49.2312"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M49.3635 41.4271V36.8105C49.3635 29.6519 47.3437 27.5772 44.8018 24.5131C44.8018 24.5131 43.0293 22.0949 43.2354 19.3194C43.414 16.9286 46.8353 16.6538 47.3574 18.9897C47.4124 19.2095 47.4399 19.4431 47.4674 19.7041C47.5635 20.9133 48.2505 21.985 49.3223 22.5346C50.71 23.2353 52.3451 22.2186 52.3451 20.6659V6.88468C52.3451 5.81296 53.2107 4.93359 54.2962 4.93359C55.3679 4.93359 56.2472 5.79922 56.2472 6.88468V18.3988"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M37.6576 9.39932L46.0528 0.756836H9.71039C4.77772 0.770576 0.765625 4.78267 0.765625 9.71534V40.2732C0.765625 45.2196 4.77772 49.2317 9.72413 49.2317H28.7129C33.6593 49.2317 37.6714 45.2196 37.6714 40.2732V9.39932H37.6576Z"
        stroke={color}
        strokeWidth="1.53888"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3349_71030">
        <rect width="68.7826" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default PersonInsideMessageBubbleAndHandSVG;
